// frontend/src/services/api.js

import axios from 'axios';

// ✅ 1. Render 서버의 기본 주소를 변수로 지정합니다.
const API_ROOT = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const apiClient = axios.create({
  // ✅ 2. 기본 URL에 '/api'를 명시적으로 추가합니다.
  baseURL: `${API_ROOT}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;